import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { RouteInfo } from "src/app/shared/sidebar/sidebar.metadata";
import { Newslatter } from "../models/newsletter_model";

@Injectable({
  providedIn: "root",
})
export class ManageNewsLettersService {
  setHeader() {
    let headers = new HttpHeaders();
    headers = headers.set("Content-Type", "application/json; charset=utf-8");
    return headers;
  }

  private sidebarnavItems: RouteInfo[] = [];
  myHeaders = this.setHeader();

  constructor(private http: HttpClient) {}
  tableSearch(value, column, pageId) {
    let url =
      environment.URL +
      "/newsLetter/" +
      value +
      "/" +
      column +
      "?page=" +
      pageId;
    return this.http.get(url, { headers: this.myHeaders });
  }
  deleteNewesLetter(bodyParams: Newslatter) {
    let url = environment.URL + "/newsLetter/delete/" + bodyParams.id;
    return this.http.get(url, { headers: this.myHeaders });
  }
  updateNewesLetter(bodyParams: Newslatter) {
    let url = environment.URL + "/newsLetter/update";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }
  saveNewsLetter(bodyParams: Newslatter) {
    let url = environment.URL + "/newsLetter/create";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }
  getAllNewesLetter() {
    let url = environment.URL + "/newsLetter/getall";
    return this.http.get(url, { headers: this.myHeaders });
  }
  newesLetterRecordById(categoryId) {
    let url = environment.URL + "/newsLetter/edit/" + categoryId;
    return this.http.get(url, { headers: this.myHeaders });
  }
  saveNewesLetter(bodyParams: Newslatter) {
    let url = environment.URL + "/newsLetter/create";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }
  getCodeList(moduleName) {
    let url = environment.URL + "/code/" + moduleName;
    return this.http.get(url, { headers: this.myHeaders });
  }
  specificCusmermail(id, email) {
    let url = environment.URL + "/newsLetterSend/" + id + "/" + email;
    return this.http.get(url, { headers: this.myHeaders });
  }
  specificCusmermSite(id) {
    let url = environment.URL + "/newsLetterSendMultiple/" + id;
    return this.http.get(url, { headers: this.myHeaders });
  }
  sendAllSite(id) {
    let url = environment.URL + "/newsLetterSendAll/" + id;
    return this.http.get(url, { headers: this.myHeaders });
  }
  fastTrackUpdate(formValue) {
    let url = environment.URL + "/code/update";
    return this.http.post(url, formValue, { headers: this.myHeaders });
  }
  pdfUpload(file: File) {
    let url = environment.URL + "/code/upload/copyrightPdfFile";
    const formData = new FormData();
    formData.append("file",file, file.name);
    return this.http.post(url, formData);
  }
  viewPdf() {
    let url = environment.URL + "/code/view/copyrightPdfFile";
    return this.http.get(url, { headers: this.myHeaders });
  }
  getAllSite(id) {
    let url = environment.URL + "/site/getall";
    return this.http.get(url, { headers: this.myHeaders });
  }
  customerCommentUpdate(formValue) {
    let url = environment.URL + "/code/update/customerCommnet";
    return this.http.post(url, formValue, { headers: this.myHeaders });
  }
}
